module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "users"
  }, _vm._l((_vm.itemsAndErrors), function(ref) {
    var id = ref.id;
    var fullName = ref.fullName;
    var error = ref.error;

    return _c('li', {
      key: id,
      staticClass: "users__items"
    }, [_c('div', {
      staticClass: "users__wrap"
    }, [_c('div', {
      staticClass: "cheked_block"
    }, [_c('Checkbox', {
      model: {
        value: (_vm.checked[id]),
        callback: function($$v) {
          _vm.$set(_vm.checked, id, $$v)
        },
        expression: "checked[id]"
      }
    }), _c('p', {
      staticClass: "users__fio"
    }, [_vm._v(_vm._s(fullName))])], 1), _c('div', {
      staticClass: "additional_block"
    }, [_c('Select', {
      attrs: {
        "options": _vm.eventOrderEduLevelsDict,
        "label": "Время",
        "large": true,
        "wide": true,
        "bold": false,
        "placeholder": "Выбрать время"
      }
    })], 1)]), (error.length) ? _c('p', {
      staticClass: "users__error"
    }, [_vm._v(_vm._s(error))]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88e41df6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/request/components/requestform/components/userslist/RequestUsersList.vue
// module id = a49a39d6185d8fcf9895
// module chunks = 6